import { } from "jquery"
import { AssetMgtCreateAssetLoader } from "./ui/page_loader/create_asset"
import { AssetMgtListAssetLoader } from "./ui/page_loader/list_asset"
import { AssetMgtExportAssetBarcodeLoader } from "./ui/page_loader/export_asset_barcode"
import { AssetMgtPageLoader } from "./ui/page_loader/index"
import { AssetMgtItemLoader } from "./ui/page_loader/asset_item"
import { AssetMgtLoanLoader } from "./ui/page_loader/asset_loan"
import { AssetMgtReturnLoader } from "./ui/page_loader/asset_return"
import { AssetMgtApi } from "./api/asset_mgt_api"

/**
 * Asset Mgt 的主要入口點.
 * 會根據目前所在路徑選取對應的 [[AssetMgtPageLoader]] 實作類別，並分別執行 [[AssetMgtPageLoader.load]] 與 [[AssetMgtPageLoader.loadOnDocumentReady]] 兩個callback methods.
 */
class AssetMgtPageLoaderMgt {
    private assetPagesMap: { [id: string]: any } = {
        '/community/assetCreate.aspx': AssetMgtCreateAssetLoader,
        '/community/assetList.aspx': AssetMgtListAssetLoader,
        '/community/assetBarcode.aspx': AssetMgtExportAssetBarcodeLoader,
        '/community/assetItem.aspx': AssetMgtItemLoader,
        '/community/assetLoan.aspx': AssetMgtLoanLoader,
        '/community/assetReturn.aspx': AssetMgtReturnLoader
    }

    private currentPageLoader?: AssetMgtPageLoader
    constructor() {
        (<any>window).AssetMgtApi = AssetMgtApi
        const loaderCls = this.assetPagesMap[location.pathname]
        if (loaderCls != null) {
            this.currentPageLoader = new loaderCls()
        }
    }

    load() {
        if (this.currentPageLoader) {
            const loadPromise = this.currentPageLoader.load()
            $(document).ready(() => {
                loadPromise.then(() => {
                    this.currentPageLoader.loadOnDocumentReady()
                })
            })
        }
    }

}

const loader = new AssetMgtPageLoaderMgt()
loader.load()